var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTarget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1828_7605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.25 10C19.25 15.1775 15.0527 19.375 9.875 19.375C4.6973 19.375 0.5 15.1775 0.5 10C0.5 4.8223 4.6973 0.625 9.875 0.625C15.0527 0.625 19.25 4.8223 19.25 10Z",
    fill: "#EFEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 10.0031C19.25 10.0031 19.25 10.0031 12.9042 10.0031C13.0109 9.95635 9.25 10.449 9.25 10.449C9.25 10.449 10.0775 13.547 13.1175 14.9726C13.911 15.3446 14.9714 16.2481 15.4984 17.5C17.7783 15.7783 19.25 13.061 19.25 10.0031Z",
    fill: "#EFE6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87508 2.5C5.73953 2.5 2.375 5.86453 2.375 10.0001C2.375 14.1355 5.73953 17.5 9.87508 17.5C14.0106 17.5 17.375 14.1356 17.375 10.0001C17.375 5.86453 14.0106 2.5 9.87508 2.5ZM9.87508 15.3758C6.91093 15.3758 4.4994 12.9642 4.4994 10.0001C4.4994 7.03593 6.91093 4.6244 9.87508 4.6244C12.8392 4.6244 15.2508 7.03593 15.2508 10.0001C15.2508 12.9642 12.8392 15.3758 9.87508 15.3758Z",
    fill: "#FD5F7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.375 10H15.1736C15.1736 12.1043 14.3584 13.7053 12.6875 14.6875C12.9295 14.8445 13.0367 14.8667 13.3125 15C13.6904 15.1824 14.1263 15.484 14.5411 15.8851C16.3631 14.4328 17.375 12.536 17.375 10Z",
    fill: "#FF737D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 10C11.75 11.0355 10.9106 11.875 9.875 11.875C8.83953 11.875 8 11.0355 8 10C8 8.96438 8.83953 8.125 9.875 8.125C10.9106 8.125 11.75 8.96438 11.75 10Z",
    fill: "#FD5F7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 10C10.6798 10.133 9.25 10.3209 9.25 10.3209C9.25 10.3209 9.43153 11.0031 9.93695 11.875C10.9162 11.7763 11.6887 10.9837 11.75 10Z",
    fill: "#FF737D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.978 8.125H17.118C16.8929 8.125 16.677 8.2135 16.5178 8.37148L14.875 10L16.5178 11.6285C16.677 11.7863 16.8929 11.875 17.118 11.875H19.978C20.4358 11.875 20.671 11.3317 20.3556 11.0026L19.7649 10.3866C19.5571 10.1699 19.5571 9.82989 19.7649 9.61323L20.3556 8.99719C20.671 8.66828 20.4358 8.125 19.978 8.125Z",
    fill: "#B2E59C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.978 8.125H17.118C16.8929 8.125 16.677 8.2135 16.5178 8.37148L14.875 10H19.609C19.609 9.86086 19.6611 9.72156 19.7649 9.61323L20.3556 8.99719C20.671 8.66828 20.4358 8.125 19.978 8.125Z",
    fill: "#7AC1DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1891 10.625H10.0609C9.61291 10.625 9.25 10.3452 9.25 10C9.25 9.65484 9.61291 9.375 10.0609 9.375H17.1891C17.6369 9.375 18 9.65484 18 10C18 10.3452 17.6369 10.625 17.1891 10.625Z",
    fill: "#B2785B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1828_7605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.4292dbb5e965cde6686da1c908e039bd.svg";
export { ForwardRef as ReactComponent };